export interface PageRouterItem {
	id: number;
	nameKey: string;
	path: string;
	isShowHeader: boolean;
	routeTitle: string;
}

export interface SnsItem {
	id: number;
	nameKey: string;
	path: string;
	path_en: string;
}

export interface NewsTypeItem {
	id: number;
	nameKey: string;
	color: string;
	textColor: string;
}

export interface PicNewsItem {
	id: number;
	banner_img: string;
	link_url: string | null;
	news_id: number;
	type: string;
}

export interface NewsItem {
	brief_introduce: string;
	id: number;
	news_type: string;
	start_date: string;
	title: string;
	content: string;
}

export const pageRouterList = ref<PageRouterItem[]>([
	{ id: 1, nameKey: "home", routeTitle: "HOME", path: "#home", isShowHeader: true },
	// { id: 2, nameKey: "news", routeTitle: "NEWS", path: "#news", isShowHeader: true },
	{ id: 3, nameKey: "character", routeTitle: "CHARACTER", path: "#character", isShowHeader: true },
	{ id: 4, nameKey: "game", routeTitle: "GAME", path: "#game", isShowHeader: true },
	{ id: 5, nameKey: "product", routeTitle: "PRODUCT", path: "#product", isShowHeader: true },
	{ id: 6, nameKey: "aboutUs", routeTitle: "ABOUT US", path: "/about", isShowHeader: true },
]);

export const snsList = ref<SnsItem[]>([
	{ id: 1, nameKey: "x", path: "https://x.com/Hakko_AI", path_en: "https://x.com/HakkoAI_en" },
	{ id: 2, nameKey: "discord", path: "https://discord.com/invite/kyzs6WCcJE", path_en: "https://discord.com/invite/kyzs6WCcJE" },
	{ id: 3, nameKey: "youtube", path: "https://youtube.com/@HakkoAI", path_en: "https://youtube.com/@HakkoAI" },
]);

export const newsTypeList = ref<NewsTypeItem[]>([
	{ id: 1, nameKey: "all", color: "#000000", textColor: "#000000" },
	{ id: 2, nameKey: "Notifications", color: "rgba(255, 194, 218, 0.4)", textColor: "rgba(255, 123, 171, 1)" },
	{ id: 3, nameKey: "Events", color: "rgba(194, 244, 255, 0.4)", textColor: "rgba(123, 145, 255, 1)" },
	{ id: 4, nameKey: "Updates", color: "rgba(255, 223, 194, 0.4)", textColor: "rgba(255, 163, 123, 1)" },
	{ id: 5, nameKey: "Others", color: "rgba(255, 194, 195, 0.4)", textColor: "rgba(255, 123, 125, 1)" },
]);
